<template>
  <v-card class="d-flex flex-column" flat light :class="dataItem.cssClasses || []"
          style="box-sizing: border-box;	border: 1.5px solid #E0E7FF;	border-radius: 5px;    height: 100%;">
    <v-card-title>
      <v-row>
        <v-col class="d-flex align-center " cols="12" md="9" style="word-break: break-word;">

          <div class="img"><img alt="" src="@/assets/images/squre.png"></div>
          <div class="pl-2 d-inline-block font-weight-bold">{{ dataItem.title }}</div>

          <!--          https://github.com/vuetifyjs/vuetify/issues/6188 open on hover false does not work -->
          <v-tooltip top v-if="dataItem.tooltip" :open-on-click="false" :open-on-hover="true" max-width="400"
                     top>
            <template v-slot:activator="{ on }">
              <span role="button" tabindex="0"  class="tooltip ml-2" v-on="on"></span>
            </template>
            {{ dataItem.tooltip }}
          </v-tooltip>
          <v-tooltip top v-if="env.isStaging" :open-on-click="false" :open-on-hover="true" max-width="400"
                     top>
            <template v-slot:activator="{ on }">
              <span role="button" tabindex="0" class="tooltip tooltip-system ml-2" v-on="on">&#9881;</span>
            </template>
            <span class="qc-status">{{ dataItem.qcStatus + ' ' }} QC </span>
            <span class="qc-status"> {{ dataItem.id.split('-')[0] }} </span>
          </v-tooltip>
        </v-col>

        <v-col class="d-flex justify-md-end" cols="12" md="3">

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div role="button" tabindex="0" class="font-weight-regular text--lighten-1 pointer" style="font-size: 14px" v-on="on">
                <v-chip color="primary"
                        light
                        small
                >
                  Source
                </v-chip>
              </div>
            </template>
            <div>{{ $t('datapoint_disclaimer') }} {{ dataItem.periodStart | dateFormat }} and
              {{ dataItem.periodEnd | dateFormat }}
            </div>
            <div>{{ $t('datapoint_disclaimer-2') }}</div>
          </v-tooltip>
          <v-divider
              role="presentation"
              class="mx-4"
              vertical
          ></v-divider>


          <v-menu open-on-hover top offset-y>
            <template v-slot:activator="{ on }">
              <button v-on="on" aria-label="download chart" class="download-file-icon ma-2 mb-0"></button>
            </template>

            <v-list>
              <v-list-item role="button" :aria-label="'download ' + mode"
                  v-for="(mode) in ['Image', 'CSV']"
                  :key="mode"
                  @click="onChartDownload(mode.toLowerCase())"
              >
                <v-list-item-title>{{ mode }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu open-on-hover top offset-y>
            <template v-slot:activator="{ on }">
              <button v-on="on" aria-label="share" class="share-icon ma-2 mb-0"></button>
            </template>

            <v-list>
              <v-list-item tabindex="0">
                <ShareNetwork
                    network="linkedin"
                    :url="socialParams.url"
                    :title="socialParams.title"
                    :description="socialParams.description"
                    :hashtags="socialParams.hashtags"
                    :quote="socialParams.title"
                >
                  <v-btn aria-label="share via linkedin"
                      @click="sendShareEvent('linkedin')"
                      dark
                      icon>
                    <v-icon class="primary-color">{{ linkedinIcon }}</v-icon>
                  </v-btn>
                </ShareNetwork>


              </v-list-item>
              <v-list-item tabindex="0">
                <ShareNetwork
                    network="facebook"
                    :url="socialParams.url"
                    :title="socialParams.title"
                    :description="socialParams.description"
                    :hashtags="socialParams.hashtags"
                    :quote="socialParams.title"
                >
                  <v-btn aria-label="share via facebook"
                      @click="sendShareEvent('facebook')"
                      dark
                      icon>
                    <v-icon class="primary-color">{{ facebookIcon }}</v-icon>
                  </v-btn>
                </ShareNetwork>
              </v-list-item>
              <v-list-item tabindex="0">
                <v-btn @click="sendShareEvent('email')"
                     aria-label="share via email"
                    :href="mailtoLink"
                    dark
                    icon
                    target="_blank"
                >
                  <v-icon class="primary-color">{{ mailIcon }}</v-icon>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-col>
        <v-col v-if="filters.includeWoWValues"
               style="word-break: break-word;">
          <div class="text-caption">
            <div class="date-label">
              {{ dataItem.periodStart | dateFormat }} -
              {{ dataItem.periodEnd | dateFormat }}:
            </div>
            <span class="label"
                  :class="dataItem.chartType[0]==='line'?'previous-label-line':'current-label'"></span>
          </div>
          <div class="text-caption">
            <div class="date-label">
              {{ dataItem.periodStart | datePreviousFormat }} -
              {{ dataItem.periodEnd | datePreviousFormat }}:

            </div>
            <span class="label"
                  :class="dataItem.chartType[0]==='line'?'previous-label-line-dashed':'previous-label'"></span>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
    <div v-if="dataItem.chartType[0] === 'cloud'">
      <top-charts v-for="item in dataItem.data" :key="item.datapointId"
                  :columnHeaders="dataItem.columnHeaders"
                  :filters="filters"
                  :data-items="item"
                  :filter-first="20"
                  :name="fileName"
                  ref="infographic">

      </top-charts>

      <top-charts v-if="dataItem.prevData" v-for="item in dataItem.prevData" :key="item.datapointId"
                  :columnHeaders="dataItem.columnHeaders"
                  :filters="filters"
                  :data-items="item"
                  :filter-first="20"
                  :name="fileName"
                  text-variant
                  ref="infographic">

      </top-charts>
      <v-card-subtitle v-if="dataItem.data[0] && dataItem.data[0].insight">
        <div class="subtitle">
          Images including <i>{{ toItalic }}</i> generate the most interest for {{ filters.category.name }}
        </div>
      </v-card-subtitle>
    </div>
    <div v-else class="chart-container">
      <div v-if="dataItem.data.length">
        <chart-renderer v-if="dataItem.data.length"
                        v-for="(data, index) in dataItem.data"
                        :key="`${data.datapointId}-${index}`" :name="fileName" ref="infographic"
                        :columnHeaders="dataItem.columnHeaders"
                        :filters="filters"
                        :chartData="data"
                        :chartPlugins="dataItem.chartPlugins || []"
                        class="pa-md-10"
                        :class="filters.includeWoWValues && dataItem.chartType[0] === 'pie'? 'col-6':undefined"
                        :chartOptions="dataItem.chartOptions || {}"
                        :chartType="dataItem.chartType"
                        :cssClass="dataItem.cssClasses"
        ></chart-renderer>
        <chart-renderer v-if="dataItem.prevData.length && dataItem.chartType[0]==='pie'"
                        v-for="(data, index) in dataItem.prevData"
                        :key="`${data.datapointId}-${index}`" :name="fileName" ref="infographic"
                        :columnHeaders="dataItem.columnHeaders"
                        :filters="filters"
                        :chartData="data"
                        :chartPlugins="dataItem.chartPlugins || []"
                        class="pa-md-10"
                        :is-prev="true"
                        :class="filters.includeWoWValues && dataItem.chartType[0] === 'pie'? 'col-6':undefined"
                        :chartOptions="dataItem.chartOptions || {}"
                        :chartType="dataItem.chartType"
                        :cssClass="dataItem.cssClasses"
        ></chart-renderer>
      </div>

      <h2 v-else class="text-center pa-4">No data to display</h2>

      <v-card-subtitle v-if="dataItem.data[0] && dataItem.data[0].insight">
        <div class="subtitle">{{ chartSummary }}</div>
      </v-card-subtitle>
    </div>
  </v-card>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import ChartRenderer from '@/components/widgets/ChartRenderer.vue';
import {DataItem} from "@/models/general";
import InfographicComponent from "@/components/base/InfographicComponent";
import {ENVIRONMENT} from "@/consts/consts";
import {Filters} from '@/models/Filters';
import TopCharts from "@/components/TopCharts.vue";
import {Utils} from "@/components/utils/utils";
import {mdiEmailOutline, mdiFacebook, mdiLinkedin} from '@mdi/js';


const moment = require('moment');
@Component({
  components: {ChartRenderer, TopCharts},
  filters: {
    dateFormat: Utils.dateFormat,
    datePreviousFormat: Utils.datePreviousFormat
  }
})
export default class ChartCard extends Vue {
  @Prop({default: null}) dataItem!: DataItem
  @Prop({type: Object, default: () => ({})}) filters!: Filters;
  @Prop({default: ''}) sectionName!: string;

  private env = ENVIRONMENT

  private infographics: InfographicComponent[];
  public $refs: Vue['$refs'] & {
    exampleComponent: ChartRenderer
  };
  private linkedinIcon: string = mdiLinkedin;
  private facebookIcon: string = mdiFacebook;
  private mailIcon: string = mdiEmailOutline;

  mounted() {
    this.infographics = this.$refs.infographic as InfographicComponent[]
  }


  onChartDownload(mode: string) {

    Utils.sendAnalyticsEvent({event: 'download chart', mode, chartName: this.dataItem.chartName})


    if (!this.infographics) {
      console.error('no infographics to download')
      return;
    }
    this.infographics.forEach(i => i.download(mode, this.dataItem))
  }

  get fileName(): string {
    let regionName = this.filters.region ? this.filters?.region?.name : 'GLOBAL'
    let verticalName = this.filters.category ? this.filters?.category?.name : 'ALL'
    return regionName + ' ' + verticalName + ' - ' + this.dataItem.title;
  }

  get chartSummary(): string {
    let text: string = this.dataItem.data[0].insight;
    if (this.dataItem.summaryIndex) {
      if (this.dataItem.summaryIndex === 1) {
        text = text.substring(
            text.indexOf(`[${this.dataItem.summaryIndex}]`) + 4,
            text.indexOf(`[${this.dataItem.summaryIndex + 1}]`))
      } else {
        text = text.substring(text.indexOf("[2]") + 4, text.length)
      }

    }
    return text;

  }

  get toItalic(): string {
    let text: string = this.dataItem.data[0].insight;
    let start = text.indexOf("including") + 10
    let end = text.indexOf("generate")
    return text.substring(start, end)
  }

  sendShareEvent(type: string){
    Utils.sendAnalyticsEvent({event: 'share chart', type})
  }


  get mailtoDisclaimer() {
    return `Outbrain data based on campaign performance between ${Utils.dateFormat(this.dataItem.periodStart).trim()} and ${Utils.dateFormat(this.dataItem.periodEnd).trim()}`
  }

  get categoryName(){
    return this.filters.category.name === 'ALL' ? 'all verticals' : this.filters.category.name
  }

  get regionName(){
    return this.filters.region.name === 'Global' ? 'all regions' : this.filters.region.name
  }

  get socialParams() {


      const title = `Insights for ${this.categoryName} in ${this.regionName}. With regards to ${this.dataItem.title.trim()}, it appears that ${this.dataItem.data[0].insight.split('%').join('%25')} Source: ${this.mailtoDisclaimer}`

    const url = 'https://outbrain.com' + window.location.pathname + window.location.search

    return {
      url,
      title,
      description: `With regards to ${this.dataItem.title.trim()}, it appears that ${this.dataItem.data[0].insight}`,
      hashtags: 'outbrain,brainpower'
    }
  }

  get mailtoLink(): string {
    const subject = `[Outbrain BrainPower] Insights for ${this.categoryName} in ${this.regionName}`
    const newLine = '%0D%0A'

    const body = [`With regards to ${this.dataItem.title.trim()}, it appears that ${this.dataItem.data[0].insight.split('%').join('%25').split('&').join('%26')}`,
      '',
      `Source: ${this.mailtoDisclaimer}`,
      '',
      `Explore additional insights for ${this.categoryName} in ${this.regionName}:`,
      `${window.location.href.split('&').join('%26')}`]

    return `mailto:?subject=${subject}&body=${body.join(newLine)}`
  }
}

</script>

<style lang="scss" scoped>
.horizental {
  .chart-container {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-flow: row wrap;
    align-items: center;

    > div {
      flex: 3
    }

    > div:nth-child(2) {
      flex: 2;
    }

    .subtitle {
      text-align: left;
      @media #{$break1} {
        text-align: center;
      }
    }
  }

}

.img {
  display: inline-block;
  position: relative;
  top: 3px;
}

.chart-renderer {
  display: inline-block;
}

div.text-caption {
  position: relative;
  grid-gap: 16px;

  .date-label {
    display: inline-block;

  }

  .label {
    display: inline-block;
    height: 12px;
    width: 12px;
    align-self: center;
    position: absolute;
    right: 0;
    left: 245px;
    top: 5px;

    &.previous-label {
      background: repeating-linear-gradient(120deg, $primary-color, #606dbc 1px, $primary-color 1px, #f3f3f3 5px);
    }

    &.current-label {
      background: $primary-color;
    }

    &.previous-label-line {
      width: 40px;
      border-top: 2px solid $primary-color;
    }

    &.previous-label-line-dashed {
      width: 40px;
      border-top: 2px dashed $primary-color;
    }
  }

}

.subtitle {
  text-align: center;
  background: #f9f9f9;
  font-size: 18px;
  padding: 10px;
}

.qc-status {
  font-size: small;
}

</style>
